<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { VyzvaSpecificationPublicResponse } from '/@src/client-public'
const { t } = useI18n()
const specResponse = inject<VyzvaSpecificationPublicResponse>('specResponse')
</script>

<template>
  <div v-if="specResponse.zoppmSpec.povinnePrilohy.length > 0">
    <IDSKHeading as="h3" variant="l">{{
      t('zoppm.step13.attachment2.mainHeading')
    }}</IDSKHeading>
    <IDSKParagraph>{{ t('zoppm.step13.attachment2.mainInfo') }}</IDSKParagraph>

    <template
      v-for="priloha in specResponse.zoppmSpec.povinnePrilohy"
      :key="priloha.povinnaPrilohaRef?.povinnaPrilohaId"
    >
      <IDSKHeading as="h4" variant="m">{{ priloha.povinnaPrilohaRef.nazov }}</IDSKHeading>
      <PreddefinedAttachment :priloha="priloha" />
    </template>
    <IDSKDivider class="mt-8 mb-8" />
  </div>
</template>

<style lang="scss"></style>
